import React from "react"
import BlockContent from "@sanity/block-content-to-react"
import ExternalLink from "./ExternalLink"
import InternalLink from "./InternalLink"

const RichText = ({ blocks, className }) => {
  return (
    <BlockContent
      blocks={blocks}
      className={className}
      serializers={{
        marks: { ExternalLink, InternalLink },
      }}
    />
  )
}

export default RichText
